export default function create(awaitableFactory) {
    return new Promise((resolve, reject) => {
        (async () => {
            try {
                resolve(await awaitableFactory());
            }
            catch (error) {
                reject(error);
            }
        })();
    });
}
